import React, { useContext, useEffect, useState } from "react";
import { Container } from "components";
import Breadcrumb from "components/molecules/Breadcrumb";
import "react-tabs/style/react-tabs.css";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import { FaCheck, FaTimes } from "react-icons/fa";
import { API_URL_spamPotential } from "constants/api";
import axios from "axios";
import { toast } from "react-toastify";

const SpamPotential = () => {
  const navigate = useNavigate();
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);
  const [text, setText] = useState("");
  const [match, setMatch] = useState(true);

  const handleChangeText = (e) => {
    const input = e.target.value;
    const regexPattern = /^([^,\s]+,\s*)+[^,\s]+$/;
    const isValid = regexPattern.test(input);
    setText(input);
    if (isValid) {
      setMatch(true);
    } else {
      setMatch(false);
    }
  };

  const fetchData = () => {
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "GET",
      url: API_URL_spamPotential + "1/",
    })
      .then((response) => {
        setText(response.data.text);
        setMatch(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "PUT",
      data: { text: text },
      url: API_URL_spamPotential + "1/",
    })
      .then((response) => {
        toast.success(response.data.message, {
          position: "top-center",
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        fetchData();
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.message, {
          position: "top-center",
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const toolbarConfig = {
    extraPlugins: "font,colorbutton,colordialog",
    removePlugins: "about,image",
    skin: "moono",
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <Container>
      <Breadcrumb
        title={"Spam Potential"}
        excludedPaths={["email", "administrator"]}
        group={"Superadmin"}
      />
      <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow">
        <div className="h-12 w-full grid items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600 text-xs md:text-base">
          Insert words that contain spam
        </div>
        <form onSubmit={handleSubmit}>
          <div className="h-auto w-auto px-4 bg-neutral dark:bg-neutral-800 border-b border-neutral-200 dark:border-neutral-600 object-left">
            <div className="mt-4 grid grid-cols-2 gap-4">
              <div>
                <label className="font-semibold">
                  Suspect spam text <span className="text-red-500">*</span> :
                </label>
              </div>

              <div className="col-span-3 mb-4">
                <textarea
                  value={text}
                  cols={4}
                  rows={4}
                  onChange={(e) => handleChangeText(e)}
                  placeholder="offering,discount,sales"
                  className="w-full border-2 p-2 dark:bg-neutral-600"
                />

                <div className="flex flex-wrap">
                  Patern (ex: offering,discount,sales) :
                  {match ? (
                    <span className="text-green-500 flex items-center ml-2">
                      <FaCheck className="mr-1" />
                      Match
                    </span>
                  ) : (
                    <span className="text-red-500 flex items-center  ml-2">
                      <FaTimes className="mr-1" /> Not Match
                    </span>
                  )}
                </div>
                <p>Character is case-sensitive</p>
              </div>
            </div>
          </div>
          <div className="h-12 w-full grid items-center px-4 bg-neutral-50 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="flex w-16 items-center justify-center p-1 rounded shadow-sm border text-white bg-sky-800 hover:bg-sky-700"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </Container>
  );
};

export default SpamPotential;
